import { format } from '@utils/string';
import ServiceResponse from '@services/models/ServiceResponse';

const USER_ID_REQUIRED_MESSAGE = 'userId param is required';

async function getUserTotalOrders({ axios, userId }) {
  try {
    if (!userId) {
      return new ServiceResponse({ error: USER_ID_REQUIRED_MESSAGE });
    }

    const userOrdersUrl = format(`/v1/users/{0}/orders/latest`, userId);
    const response = await axios.get(userOrdersUrl);

    return new ServiceResponse({
      data: response?.data,
    });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getUserTotalOrders;
